import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "benefits container" }
const _hoisted_2 = { class: "benefits__list" }
const _hoisted_3 = { class: "benefits__item-text" }


export default /*@__PURE__*/_defineComponent({
  __name: 'Benefits',
  setup(__props) {

const benefits = [
  '10,000+ books covered',
  'Community discussions',
  '500+ article and topic guides',
  'Comprehensive podcast summaries',
  'Mobile app (iOS/Android)',
  'Kindle exports',
  'Highlights & notes',
  'PDF downloads',
  'Audio narrations',
  'Premium access to Shortform browser extension',
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "billing-data__title" }, "A Comprehensive Suite of Learning Tools", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(benefits, (benefit) => {
        return _createElementVNode("div", {
          key: benefit,
          class: "benefits__item"
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "benefits__item-icon" }, [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none"
            }, [
              _createElementVNode("path", {
                d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
                fill: "#FFC906"
              }),
              _createElementVNode("path", {
                d: "M17 10L11.5371 15.9073C11.5135 15.9367 11.4856 15.96 11.4548 15.9759C11.424 15.9918 11.391 16 11.3577 16C11.3244 16 11.2914 15.9918 11.2606 15.9759C11.2298 15.96 11.2019 15.9367 11.1783 15.9073L8 12.3077",
                stroke: "#363B48",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_3, _toDisplayString(benefit), 1)
        ])
      }), 64))
    ])
  ]))
}
}

})